// Builds a product card from the index.
// Markup and class names must match snippets/product_card.liquid and feature-product-card.liquid.
(function () {
  'use strict';

  const SPEC_ROWS = [
    ['lumens', 'Lumens'],
    ['tilt_angle', 'Tilt Angle'],
    ['watts', 'Watts'],
    ['rotate_angle', 'Rotate Angle'],
    ['cut_out', 'Cut Out']
  ];

  const SWATCH_LIMIT = 6;

  const PLUS_ICON =
    "<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' class='plus'>" +
    '<path d="M2.5 8H13.5" stroke="black" stroke-linejoin="round"/>' +
    '<path d="M8 2.5V13.5" stroke="black" stroke-linejoin="round"/></svg>';
  const CLOSE_ICON =
    "<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' class='close'>" +
    '<path d="M12.5 3.5L3.5 12.5" stroke="black" stroke-linejoin="round"/>' +
    '<path d="M12.5 12.5L3.5 3.5" stroke="black" stroke-linejoin="round"/></svg>';
  const HEART_ICON =
    "<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>" +
    '<path d="M6.00031 10.0003L10.1891 5.75156C10.6287 5.31196 10.8756 4.71574 10.8756 4.09406C10.8756 3.47238 10.6287 2.87616 10.1891 2.43656C9.74946 1.99696 9.15324 1.75 8.53156 1.75C7.90988 1.75 7.31366 1.99696 6.87406 2.43656L6.00031 3.25031L5.12656 2.43656C4.68696 1.99696 4.09074 1.75 3.46906 1.75C2.84738 1.75 2.25116 1.99696 1.81156 2.43656C1.37196 2.87616 1.125 3.47238 1.125 4.09406C1.125 4.71574 1.37196 5.31196 1.81156 5.75156L6.00031 10.0003Z" stroke="black" stroke-linejoin="round"/></svg>';
  const HEART_FILLED =
    "<svg xmlns='http://www.w3.org/2000/svg' width='11' height='10' viewBox='0 0 11 10' fill='none'>" +
    '<path d="M5.37531 8.75031L9.56406 4.50156C10.0037 4.06196 10.2506 3.46574 10.2506 2.84406C10.2506 2.22238 10.0037 1.62616 9.56406 1.18656C9.12446 0.746963 8.52824 0.5 7.90656 0.5C7.28488 0.5 6.68866 0.746963 6.24906 1.18656L5.37531 2.00031L4.50156 1.18656C4.06196 0.746963 3.46574 0.5 2.84406 0.5C2.22238 0.5 1.62616 0.746963 1.18656 1.18656C0.746963 1.62616 0.5 2.22238 0.5 2.84406C0.5 3.46574 0.746963 4.06196 1.18656 4.50156L5.37531 8.75031Z" fill="currentColor" stroke="currentColor" stroke-linejoin="round"/></svg>';
  const COMPARE_ICON =
    "<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>" +
    '<path d="M1.875 6H10.125" stroke="black" stroke-linejoin="round"/>' +
    '<path d="M6 1.875V10.125" stroke="black"/></svg>';

  function escapeHtml(value) {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  const CDN_FILES = /^https?:\/\/cdn\.shopify\.com\/s\/files\/\d+\/[\d/]+\/files\//;

  // image_url serves the files path from the storefront domain, so the host is dropped.
  function onStorefront(url) {
    return url ? String(url).replace(CDN_FILES, '/cdn/shop/files/') : '';
  }

  function sized(url, width, format) {
    if (!url) {
      return '';
    }
    const [path, search] = String(url).split('?');
    const params = new URLSearchParams(search || '');
    params.set('width', String(width));
    if (format) {
      params.set('format', format);
    }
    const sorted = Array.from(params.keys())
      .sort()
      .map((key) => key + '=' + params.get(key))
      .join('&');
    return onStorefront(path) + '?' + sorted;
  }

  // Matches money_without_trailing_zeros. A whole amount shows no cents.
  function money(amount, format) {
    if (amount === null || amount === undefined) {
      return '';
    }
    const number = Number(amount);
    if (!isFinite(number)) {
      return '';
    }
    const whole = Math.round(number * 100) % 100 === 0;
    const text = whole ? String(Math.round(number)) : number.toFixed(2);
    const withSeparators = text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, withSeparators);
  }

  // The config already picked the rule for this customer, so only the product test is left.
  function discountApplies(product, index, discount) {
    const handles = discount.collections || [];
    for (let i = 0; i < handles.length; i += 1) {
      if (product.collections.has(index.code(handles[i]))) {
        return true;
      }
    }
    const variants = discount.variants || [];
    return variants.indexOf(String(product.variantId)) !== -1;
  }

  // Mirrors the arithmetic in snippets/product-price.liquid, in dollars rather than cents.
  function priceOf(product, index, config) {
    const discount = config.discount;
    if (!discount || product.price === null || product.price === undefined) {
      return product.price;
    }
    if (!discountApplies(product, index, discount)) {
      return product.price;
    }
    if (discount.type === 'fixed') {
      return Math.max(0, product.price - Number(discount.value));
    }
    return product.price - (product.price * Number(discount.value)) / 100;
  }

  // Matches product-trim-title.liquid. Keeps the first few dash separated parts of the sku.
  function trimmedTitle(product) {
    const stored = Number(product.trim || 0);
    const level = stored > 0 ? stored : 1;
    const source = product.sku ? product.sku : product.title;
    if (!source) {
      return product.title || '';
    }
    const parts = String(source).replace(/ /g, '-').split('-');
    return parts.slice(0, level).join('-');
  }

  function spec(product, index, key) {
    const at = index.specAt[key];
    return at === undefined ? '' : index.text(product.specs[at]);
  }

  function finishLabel(product, index) {
    const at = index.listAt.finish;
    const values = at === undefined ? null : product.lists[at];
    if (!values || values === 0) {
      return '';
    }
    return values.map((code) => index.text(code)).join(', ');
  }

  function badge(product, index) {
    for (let i = 0; i < product.tags.length; i += 1) {
      const tag = index.text(product.tags[i]);
      if (tag.indexOf('badge_') !== -1) {
        return '<p>' + escapeHtml(tag.replace('badge_', '')) + '</p>';
      }
    }
    return '';
  }

  function productUrl(handle, collection) {
    const path = '/products/' + handle;
    return collection ? '/collections/' + collection + path : path;
  }

  function swatchOf(product, index) {
    return {
      name: index.text(product.swatchName),
      color: index.text(product.swatchColor),
      image: index.text(product.swatchImage),
      handle: product.handle,
      preview: product.image
    };
  }

  // Must match the order in snippets/product-swatches.liquid.
  function swatchList(product, index) {
    const slug = window.SACatalogIndex.slug;
    const seen = {};
    const chosen = [];
    const rest = [];

    const own = swatchOf(product, index);
    if (own.name) {
      seen[slug(own.name)] = true;
      own.isActive = true;
      chosen.push(own);
    }

    const siblings = [];
    for (let i = 0; i < product.group.length; i += 1) {
      const sibling = index.byId.get(String(product.group[i]));
      if (!sibling || sibling.handle === product.handle) {
        continue;
      }
      const entry = swatchOf(sibling, index);
      if (!entry.name) {
        continue;
      }
      siblings.push(entry);
    }

    ['white', 'black'].forEach((wanted) => {
      for (let i = 0; i < siblings.length; i += 1) {
        if (slug(siblings[i].name) === wanted && !seen[wanted]) {
          seen[wanted] = true;
          chosen.push(siblings[i]);
          return;
        }
      }
    });

    const pending = {};
    siblings.forEach((entry) => {
      const key = slug(entry.name);
      if (seen[key] || pending[key]) {
        return;
      }
      pending[key] = true;
      rest.push(entry);
    });

    // Padded so a shorter name sorts before a longer one sharing its start.
    const padded = (entry) => (entry.name + '                                                                ').slice(0, 64).toLowerCase();
    rest.sort((a, b) => {
      const left = padded(a);
      const right = padded(b);
      return left < right ? -1 : left > right ? 1 : 0;
    });

    const total = chosen.length + rest.length;
    const shown = chosen.concat(rest).slice(0, SWATCH_LIMIT);
    return { shown: shown, remaining: total - shown.length };
  }

  function swatchMarkup(product, index, collection, previewWidth, previewFormat) {
    const list = swatchList(product, index);
    if (list.shown.length === 0) {
      return '';
    }

    const items = list.shown.map(function (entry) {
      const slug = window.SACatalogIndex.slug(entry.name);
      let style = 'background-color: ' + escapeHtml(entry.color) + ';';
      if (entry.image) {
        style += 'background-image: url(' + escapeHtml(entry.image) + ');';
      }
      const preview = entry.preview ? sized(entry.preview, previewWidth, previewFormat) : '';
      return (
        "<li class='swatch-" + escapeHtml(slug) + (entry.isActive ? ' is-active' : '') + "'>" +
        "<a href='" + escapeHtml(productUrl(entry.handle, collection)) + "'" +
        ' data-card-swatch' +
        " aria-label='View " + escapeHtml(entry.name) + " finish'" +
        (entry.isActive ? " aria-current='true'" : '') +
        (preview ? " data-swatch-preview='" + escapeHtml(preview) + "'" : '') +
        '>' +
        "<span class='swatch-item' style='" + style + "'></span>" +
        '</a></li>'
      );
    });

    if (list.remaining > 0) {
      items.push("<li class='swatch-more'>+ " + list.remaining + '</li>');
    }
    return items.join('');
  }

  function specRows(product, index, wrap) {
    return SPEC_ROWS.map(function (row) {
      const value = spec(product, index, row[0]);
      if (!value) {
        return '';
      }
      // Liquid strips the escaped less-than that some lumens values carry.
      const clean = row[0] === 'lumens' ? value.replace(/&lt;/g, '') : value;
      return wrap(row[1] + ' ' + escapeHtml(clean));
    }).join('');
  }

  function gridSpecRows(product, index) {
    return specRows(product, index, (text) => '<li><p><span>' + text + '</span></p></li>');
  }

  function listSpecRows(product, index) {
    return specRows(product, index, (text) => '<p><span>' + text + '</span></p>');
  }

  function compareAttributes(product, index, config) {
    const pairs = [
      ['data-title', product.title],
      ['data-sku', product.sku],
      ['data-image', onStorefront(product.image)],
      ['data-product-id', product.id],
      ['data-url', productUrl(product.handle, null)],
      ['data-product-highlight', product.title],
      ['data-finish', finishLabel(product, index)],
      ['data-beam-angle', spec(product, index, 'spec_beam_angle')],
      ['data-watts', spec(product, index, 'watts')],
      ['data-lumens', spec(product, index, 'lumens')],
      ['data-colour-temp', spec(product, index, 'colour_temp')],
      ['data-min-max-output', spec(product, index, 'min_max_output')],
      ['data-dimensions', spec(product, index, 'dimensions')],
      ['data-cut-out', spec(product, index, 'cut_out')],
      ['data-driver', spec(product, index, 'driver')],
      ['data-tilt-angle', spec(product, index, 'tilt_angle')],
      ['data-rotate-angle', spec(product, index, 'rotate_angle')],
      ['data-compare-price', money(product.compareAt, config.moneyFormat)],
      ['data-price', config.customerId ? money(priceOf(product, index, config), config.moneyFormat) : '']
    ];
    return pairs
      .map(function (pair) {
        return pair[0] + "='" + escapeHtml(pair[1] === undefined ? '' : pair[1]) + "'";
      })
      .join(' ');
  }

  function wishlistButton(product, config) {
    return (
      '<add-to-wishlist-button' +
      " product-id='" + escapeHtml(product.id) + "'" +
      " variant-id='" + escapeHtml(product.variantId) + "'" +
      " customer-id='" + escapeHtml(config.customerId || '') + "'" +
      " shop-domain='" + escapeHtml(config.shopDomain || '') + "'" +
      " button-text='favourite'" +
      " button-class='wishlist-button'" +
      " login-url='/account/login'" +
      " quantity='1'" +
      " text-color='#000'" +
      '></add-to-wishlist-button>'
    );
  }

  function render(product, index, config) {
    const collection = config.collection || null;
    const url = productUrl(product.handle, collection);
    const specs = gridSpecRows(product, index);
    const swatchItems = swatchMarkup(product, index, collection, 900, 'webp');
    const compareAttrs = compareAttributes(product, index, config);
    const wishlist = wishlistButton(product, config);

    const contentClasses =
      'product-card__content' +
      (specs === '' ? ' empty-specs' : '') +
      (swatchItems === '' ? ' no-swatches' : '');

    return (
      "<div class='product-card' data-card-preview data-handle='" + escapeHtml(product.handle) + "'" +
      " wishlist='" + escapeHtml(config.wishlist || '') + "'>" +
      "<div class='product-card__wrapper'>" +
      "<div class='product-card__image'>" +
      "<img src='" + escapeHtml(sized(product.image, 900, 'webp')) + "'" +
      " alt='" + escapeHtml(product.title) + "'" +
      " width='400' height='400' loading='lazy' data-card-preview-image" +
      " class='product-card__image product-card__image--img'>" +
      "<a href='" + escapeHtml(url) + "' class='product-card__link'></a>" +
      "<button class='product-card__action-button md-show' type='button'>" + PLUS_ICON + CLOSE_ICON + '</button>' +
      "<div class='product-card__mobile-actions hidden'>" +
      "<div class='product-card__actionable-container'>" +
      "<div class='product-card__buttons'>" +
      "<div class='product-card__button button--save' title='Add to wishlist'>" +
      "<span class='button_icon'>" + HEART_ICON + '</span>' +
      '<span>' + wishlist + '</span>' +
      '</div>' +
      "<button type='button' class='product-card__button button--compare product-compare-trigger-js' " +
      compareAttrs + '>' +
      "<span class='button_icon'>" + COMPARE_ICON + '</span><span>Compare</span>' +
      '</button></div></div></div></div>' +
      "<div class='" + contentClasses + "'>" +
      "<div class='product-card__container" + (swatchItems === '' ? ' no-swatches' : '') + "'>" +
      "<div class='product-card__container__header'>" +
      "<h3 class='product-card__title'>" + escapeHtml(trimmedTitle(product)) + '</h3>' +
      "<div class='product-card__subtitle'>" +
      '<p>' + escapeHtml(product.title) + '</p>' +
      "<p class='product-card__price'>" + money(priceOf(product, index, config), config.moneyFormat) +
      ' <span>+</span><span>GST</span></p>' +
      '</div>' +
      "<div class='product-card__swatches'><ul>" + swatchItems + '</ul></div>' +
      '</div>' +
      (specs === ''
        ? ''
        : "<div class='product-card__container__footer'><ul class='product-card__features'>" +
          specs +
          '</ul></div>') +
      '</div>' +
      "<a href='" + escapeHtml(url) + "' class='product-card__link-mobile'></a>" +
      '</div>' +
      "<div class='product-card__badge'>" + badge(product, index) +
      "<span class='product-card__wishlist-active' aria-hidden='true'>" + HEART_FILLED + '</span>' +
      '</div>' +
      "<div class='product-card__actions'>" +
      "<div class='product-card__button button--save' title='Add to favorite'>" +
      "<span class='button_icon'>" + HEART_ICON + '</span>' +
      '<span>' + wishlist + '</span>' +
      '</div>' +
      "<button type='button' class='product-card__button button--compare product-compare-trigger-js' " +
      compareAttrs + '>' +
      "<span class='button_icon'>" + COMPARE_ICON + '</span><span>Compare</span>' +
      '</button></div></div></div>'
    );
  }

  // Must match snippets/feature-product-card.liquid.
  function renderListCard(product, index, config) {
    const collection = config.collection || null;
    const url = productUrl(product.handle, collection);
    const specs = listSpecRows(product, index);
    const swatchItems = swatchMarkup(product, index, collection, 512, null);
    const compareAttrs = compareAttributes(product, index, config);
    const wishlist = wishlistButton(product, config);

    return (
      "<div class='featured-product__card' data-card-preview>" +
      "<div class='featured-product__card__wrapper'>" +
      "<div class='featured-product__card__image'>" +
      "<img src='" + escapeHtml(sized(product.image, 512, null)) + "'" +
      " width='148' height='180' loading='lazy' data-card-preview-image alt=''>" +
      '</div>' +
      "<div class='featured-product__card__content'>" +
      "<div class='featured-product__card__header'>" +
      "<div class='featured-product__card__row'>" +
      "<h3 class='featured-product__card__title'>" + escapeHtml(trimmedTitle(product)) + '</h3>' +
      "<div class='featured-product__card__actions'>" +
      "<div class='featured-product__card__button featured-product__card__button--save' title='Add to favorite'>" +
      "<span class='action__icon'>" + HEART_ICON + '</span>' +
      '<span>' + wishlist + '</span>' +
      '</div>' +
      "<button class='product-compare-trigger-js featured-product__card__button featured-product__card__button--compare' type='button' " +
      compareAttrs + '>' +
      "<span class='action__icon'>" + COMPARE_ICON + '</span><span>Compare</span>' +
      '</button></div></div>' +
      "<div class='featured-product__card__information'>" +
      '<p>' + escapeHtml(product.title) + '</p>' +
      "<p class='featured-product__card__price'><span>" +
      money(priceOf(product, index, config), config.moneyFormat) +
      ' </span><span>+</span><span>GST</span></p>' +
      '</div>' +
      (swatchItems === ''
        ? ''
        : "<div class='product-card__swatches featured-product__card__swatches'><ul>" +
          swatchItems +
          '</ul></div>') +
      '</div>' +
      (specs === '' ? '' : "<div class='featured-product__card__footer'>" + specs + '</div>') +
      '</div>' +
      "<a href='" + escapeHtml(url) + "' class='featured-product__card__link'></a>" +
      '</div></div>'
    );
  }

  window.SACatalogCard = {
    onStorefront: onStorefront,
    render: render,
    renderListCard: renderListCard,
    money: money,
    priceOf: priceOf,
    trimmedTitle: trimmedTitle,
    escapeHtml: escapeHtml,
    sized: sized
  };
})();
